module.exports = __webpack_public_path__ + "static/media/DSK.ded755fa.webm";